import { jsx as _jsx } from "react/jsx-runtime";
import { IconProvider } from "@ant-design/icons";
import { App, ConfigProvider } from "antd";
import { RootStore } from "../store/stores.js";
const IMPREZA_BUTTON_PROPS = {
    className: "w-btn"
};
const Provider = (param)=>{
    let { children, configProvider = {}, app = {} } = param;
    return /*#__PURE__*/ _jsx(ConfigProvider, {
        prefixCls: process.env.ANTD_PREFIX,
        iconPrefixCls: `${process.env.ANTD_PREFIX}-anticon`,
        theme: {
            token: {
                // Match devowl.io WordPress theme
                colorPrimary: "#45b3dd",
                borderRadius: 3,
                fontSize: 15,
                colorText: "#666666",
                colorBgContainer: "#f2f4f7"
            },
            components: {
                Button: {
                    colorPrimaryHover: "#469bc3"
                },
                Table: {
                    colorBgContainer: "white"
                }
            }
        },
        ...configProvider,
        children: /*#__PURE__*/ _jsx(IconProvider, {
            value: {
                prefixCls: `${process.env.ANTD_PREFIX}-anticon`
            },
            children: /*#__PURE__*/ _jsx(App, {
                message: {
                    top: 150
                },
                ...app,
                children: /*#__PURE__*/ _jsx(RootStore.StoreProvider, {
                    children: children
                })
            })
        })
    });
};
export { Provider, IMPREZA_BUTTON_PROPS };
